export default __webpack_public_path__ + "6ade1d28d8bb6bbcd92bf66cadd7611b.png";